<template>
  <div>
    <popup ref="popup" :loading="popupLoading" :appendToBody="true">
      <div slot="body" style="margin-top: -15px">

        <el-form class="dataForm" ref="form" :model="formParameter" :inline="true" label-width="60px">
          <el-row>
    
            <el-col :span="24">
              <el-table class="table" :data="parameter" stripe border height="auto">
                <el-table-column label="序号" width="60px" type="index">
                  <template slot-scope="scope">
                    {{ idx }}/{{ sizeConus }}
                  </template>
                </el-table-column>
                <el-table-column prop="mobile" label="咨询量" min-width="75px">
                  <template slot-scope="scope">
                    <b v-if="formParameter.sex == '女'" style="font-size: 18px;color:deeppink;">{{ formParameter.name
                      }}</b>
                    <b v-else style="font-size: 18px;color: #3333CC;">{{ formParameter.name }}</b> <br>
                    <br>
                    {{ scope.row.mobile }}

                  </template>
                </el-table-column>
                <el-table-column prop="name" label="跟进人" width="75px">
                  <template slot-scope="scope">
                    <el-tag type="warning" size="mini" v-if="scope.row.dyer">{{ scope.row.dyer }}</el-tag>
                    <el-tag type="success" size="mini" v-if="scope.row.zxer">{{ scope.row.zxer }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="state" min-width="80px" label="状态与评价">
                  <template slot-scope="scope">
                    <el-rate disabled show-text :max="4" v-model="scope.row.rank"
                      :texts="['D', 'C', 'B', 'A']"></el-rate>
                    <el-select v-model="scope.row.state" placeholder="请选择">
                      <el-option v-for="item in ['有意向', '可跟进', '意向不大', '无意向', '已报名', '未接通', '废量']" :key="item"
                        :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column min-width="70px" prop="city" label="当前所在城市">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.city" autocomplete="off"></el-input>
                  </template>
                </el-table-column>
                <el-table-column min-width="300px" prop="remark" label="跟进记录">
                  <template slot-scope="scope">
                    <el-input type="textarea" :rows="4" v-model="scope.row.txt" autocomplete="off"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="hasresume" width="110px" label="">
                  <template slot-scope="scope">
                    <el-button type="primary" :loading="confirmLoading" @click="confirm()">提 交</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>

          </el-row>
          <el-row :style="formParameter.sex == '女' ? 'background-color: #FFCCCC;' : 'background-color:#66CCFF;'">
            <el-col :span="3">
              <el-form-item label="性别" prop="sex">
                <el-select size="mini" v-model="formParameter.sex" placeholder="请选择">
                  <el-option v-for="item in ['男', '女']" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="意向" prop="post">
                <el-select size="mini" v-model="formParameter.post" placeholder="请选择">
                  <el-option v-for="item in ['大专', '本科', '中专','其他']" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="学校" prop="schoolid">
                <el-input size="mini" v-model="formParameter.schoolid" autocomplete="off"></el-input></el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="现学历" prop="grade">
                <el-select size="mini" v-model="formParameter.grade" placeholder="请选择">
                  <el-option v-for="item in ['高中', '大专', '低学历']" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="专业" prop="subject">
                <el-input size="mini" v-model="formParameter.subject" autocomplete="off"></el-input></el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="毕业" prop="gradedate">
                <el-date-picker size="mini" v-model="formParameter.gradedate" value-format="yyyy" type="year"
                  placeholder="选择年">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :style="formParameter.sex == '女' ? 'background-color: #FFCCCC;' : 'background-color:#66CCFF;'">

            <el-col :span="16">
              <el-col :span="6">
              <el-form-item label="类型" prop="type"><el-select v-model="formParameter.type" 
                  placeholder="请选择">
                  <el-option v-for="item in ['推广', '转介绍', '自招']" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
              <el-form-item label="备注" prop="remark">
                <el-input v-model="formParameter.remark" autocomplete="off"></el-input></el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button type="danger" size="mini" v-has-permission-code-and="'003000550010'"
                @click="updated()">信息更新</el-button>
            </el-col>
          </el-row>
        </el-form>

        <el-table class="table" :data="listRecords" stripe border height="auto">
          <el-table-column label="序号" width="50px" type="index">
            <template slot-scope="scope">
              {{ sizeRecord - scope.$index }}
            </template>
          </el-table-column>
          <el-table-column prop="gjdate" label="跟进时间" width="140px">
          </el-table-column>
          <el-table-column prop="uid" width="70px" label="跟进人">
          </el-table-column>
          <el-table-column width="70px" prop="rank" label="评价">
            <template slot-scope="scope">
              <el-tag type="danger" size="mini" v-if="scope.row.rank == 1">D量</el-tag>
              <el-tag type="warning" size="mini" v-if="scope.row.rank == 2">C量</el-tag>
              <el-tag size="mini" v-if="scope.row.rank == 3">B量</el-tag>
              <el-tag type="success" size="mini" v-if="scope.row.rank == 4">A量</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="state" width="100px" label="状态"> </el-table-column>
          <el-table-column prop="city" width="120px" label="所在城市"> </el-table-column>

          <el-table-column prop="remark" label="跟进情况"> </el-table-column>
          <el-table-column label="操作" fixed="right" width="65px">
            <template slot-scope="scope">
              <div class="dataTable-operator">
                <el-button type="text" v-show="scope.row.id" v-has-permission-code-and="'003000550010'"
                  @click="remove(scope.$index, scope.row)" size="mini">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div slot="footer" style="text-align: center">
        <el-button :type="prebtn" size="medium" round :loading="confirmLoading" @click="move(-1)">{{ prebtn == "primary"
      ?
      "上一条" : "--end--" }}</el-button>
        <el-button type="danger" @click="close" size="medium">关闭</el-button>
        <el-button :type="nextbtn" size="medium" round :loading="confirmLoading" @click="move(1)">{{ nextbtn ==
      "primary"
      ? "下一条" : "--end--" }}</el-button>
      </div>

    </popup>
    
  </div>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/consu/consultationxl/consultationxl.js";
import apircd from "@/api/consu/consultationxl/consultationrecordxl.js";

import constant from "@/util/constant.js";

export default {
  name: "attckone",
  components: {
    popup
  },
  data() {
    return {
      baseUrl: constant.serverUrl,
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: [],
      formParameter: {},
      listRecords: [],
      sizeRecord: 0,
      remark: "",
      me: "",
      zxs: [],
      isCangj: true,
      isCangjTxt: true,

      listConus: [],
      idx: 1,
      sizeConus: 1,
      prebtn: "info",
      nextbtn: "primary",

      dialogTitle: '',
      dialogFormVisible: false,
      expaperList: [],
      examform: {},
      examName: '基础知识测评',
      realExamName: '',

      helpDialogVisible: false,
      helpform: {},
      listNeedFlush: 0
    };
  },
  methods: {

    //打开弹框
    open(index, list, me, zxs, title, disabled, size) {

      this.listNeedFlush = 0

      this.listConus = list;
      // console.log("this.listConus.size()" + this.listConus.length)
      this.sizeConus = this.listConus.length;
      this.idx = index + 1;

      if (this.idx == 1) {
        this.prebtn = "info";
      } else {
        this.prebtn = "primary";
      }

      if (this.idx == this.sizeConus) {
        this.nextbtn = "info";
      } else {
        this.nextbtn = "primary";
      }

      let consu = this.listConus[index]

      api.oneConus({ id: consu.id }, res => {

        this.parameter = res.data.records
        this.formParameter = this.parameter[0]
        this.formParameter.vdate = new Date();
        this.dialogTitle = this.formParameter.name + '-线上测评布置'
        this.disabled = disabled;

        this.me = me;
        this.zxs = zxs;
        this.checkIsCangj();

        this.$refs.popup.open(title, "75%");
        this.$nextTick(() => {
          this.init();
        });
      })


    },
    updated() {
      let param = {
        id: this.formParameter.id, sex: this.formParameter.sex, post: this.formParameter.post,
        schoolid: this.formParameter.schoolid, grade: this.formParameter.grade, subject: this.formParameter.subject,
        gradedate: this.formParameter.gradedate, remark: this.formParameter.remark,type:this.formParameter.type
      }
      api.update(param, res => {
        //this.listNeedFlush++;
        this.$utils.msg.success(res.msg);
      }, err => {
        this.$utils.msg.warning(err.msg);
      })

    },
    toHelp() {
      this.helpform = { level: "1" }
      this.helpDialogVisible = true
    }, 
    //删除
    remove(index, row) {
      let parameter = {
        rid: row.id,
      };

      if (row.uid == this.me.name || (this.me.role == "ad" || this.me.role == "mg")) {
      } else {

        if(row.remark.indexOf(this.me.name+"-" )==0){
          
        }else{
          this.$utils.msg.warning("只能删除自己的");
          return false;
        }
      }

      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.delRecordByRid(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.listRecords.splice(index, 1);
            this.sizeRecord--;
            this.listNeedFlush++;
 
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.votes = [];
      this.$refs.popup.close();
      this.$parent.loaddata();
      //this.$emit("flush");
      

    },
    move(flag) {

      if (
        (flag < 0 && this.idx > 1) ||
        (flag > 0 && this.idx < this.sizeConus)
      ) {
        this.idx += flag;

        if (this.idx == 1) {
          this.prebtn = "info";
          if (this.idx != this.sizeConus) {
            this.nextbtn = "primary";
          }
        } else if (this.idx == this.sizeConus) {
          this.nextbtn = "info";
          if (this.idx != 1) {
            this.prebtn = "primary";
          }
        } else {
          this.prebtn = "primary";
          this.nextbtn = "primary";
        }
        this.confirmLoading = true;

        let consu = this.listConus[this.idx - 1]

        api.oneConus({ id: consu.id }, res => {

          this.parameter = res.data.records
          this.formParameter = this.parameter[0]

          this.checkIsCangj();
          this.formParameter.vdate = new Date();

          apircd.list({ coid: this.formParameter.id }, (res) => {
            if (res.data.records) {
              this.listRecords = res.data.records;
              if (this.listRecords) {
                this.sizeRecord = this.listRecords.length;
                if (this.listRecords[0] && this.listRecords[0].city) {
                  this.$set(this.formParameter, "city", this.listRecords[0].city)
                }
                this.$forceUpdate()
              }
            }
            this.confirmLoading = false;
          });
        })
      }
    },
    //提交表单
    confirm() {

      if(this.formParameter.state == "录入待通知"){
        this.$utils.msg.warning("请设置-数据状态");
        return false;
      }


        this.confirmLoading = true;

        let ids = [this.formParameter.id];
        let rank = this.formParameter.rank;
        let states = [this.formParameter.state];
        let vdate = this.formParameter.vdate;
        let remarks = [this.formParameter.txt];
        let cities = [this.formParameter.city];

        if(this.parameter[0].state =='有意向' ||this.parameter[0].state =='已上门'    ){
          rank =4;
        }else if(this.parameter[0].state =='可跟进'   ){
          rank =3;
        }else if(this.parameter[0].state =='意向不大'   ){
          rank =2;
        }else if(this.parameter[0].state =='无意向' || this.parameter[0].state=='废量'   ){
          rank =1;
        }

        let param = {
          ids: ids,
          vdate: vdate,
          remarks: remarks,
          states: states,
          cities: cities
        };

        api.attact(
          param,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.listRecords.splice(0, 0, {
              gjdate: "刚刚",
              remark: remarks[0],
              uid: "自己",
              rank: rank,
              city: cities[0],
              state: states[0]
            });
            this.sizeRecord++;
            this.listNeedFlush++;
            this.formParameter.vdate = new Date();
            this.remark = "";

            this.formParameter.rank = rank;
            this.formParameter.state = states[0];
            this.formParameter.city = cities[0];
            this.listConus[this.idx - 1] = this.formParameter;

          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      
    },
    checkIsCangj() {
      this.isCangj = true;
      this.isCangjTxt = "提交跟进";
      if (
        this.me.role == "zx" ||
        this.me.role == "qd"
      ) {
        //验证是否可以跟进
        if (this.me.name != this.formParameter.zxer) {
          this.isCangj = false;
          if (this.me.role == "zm" && this.formParameter.zxer) {
            this.isCangjTxt = "指导" + this.formParameter.zxer + "咨询";
            this.isCangj = true;
          }
        }
      }
    },
    init() {
      //清除等待
      this.confirmLoading = false;
      this.listNeedFlush = 0

      //console.log("formParameter", this.formParameter)

      apircd.list({ coid: this.formParameter.id }, (res) => {
        if (res.data.records) {
          this.listRecords = res.data.records;
          if (this.listRecords) {
            this.sizeRecord = this.listRecords.length;
            if (this.listRecords[0] && this.listRecords[0].city) {
              this.$set(this.formParameter, "city", this.listRecords[0].city)
            }
          }
        }
      });

      //清楚校验
      this.$refs.form.clearValidate();
      this.popupLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
